import React from 'react';
import BillingDetailDTO from 'features/billings/dtos/BillingDetailDTO';
import PriceFormatter from 'features/shared/components/formatters/PriceFormatter';
import NumberFormatter from 'features/shared/components/formatters/NumberFormatter';
import DateFormatter from 'features/shared/components/formatters/DateFormatter';
import styles from './billingDetail.module.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  billingDetail: BillingDetailDTO;
  periodFrom: Date;
  periodTo: Date;
}

const BillingDetail = ({ billingDetail, periodFrom, periodTo }: Props) => {
  // translations
  const tLabels = useTranslation(["billings\\billings"]).t;

  // helpers
  const isSameDate = (date1: Date, date2: Date) => {
    if (date1 && date2) {
      let d1 = new Date(date1); 
      let d2 = new Date(date2);

      return d1.getTime() === d2.getTime();
    }
    
    return false;
  }

  // sub-renders
  const renderDates = () => {
    if (
      !isSameDate(billingDetail.from!, periodFrom) ||
      !isSameDate(billingDetail.to!, periodTo)
    ) {
      return (
        <div
          className={`d-flex d-lg-block justify-content-between ${styles.dates}`}
        >
          <span className="text-muted">{tLabels("billingDetail.timePeriod")}</span>
          <span>
            <DateFormatter date={billingDetail.from!} />
            <span> - </span>
            <DateFormatter date={billingDetail.to!} />
          </span>
        </div>
      );
    }
  };

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col-lg-6">
        <div className="mb-1 mb-lg-0">
          {billingDetail.label}
        </div>
        {renderDates()}
      </div>
      <div className="col-lg-2 text-lg-right">
        <div className="d-flex d-lg-block justify-content-between">
          <div className="d-lg-none text-muted pr-2">
            {tLabels("billingDetail.quantity")}
          </div>
          <div>
            <NumberFormatter 
              amount={billingDetail.quantity!}
              decimalPlaces={3}
            />
            <span> {billingDetail.unit}</span>
          </div>
        </div>
      </div>
      <div className="col-lg-2 text-lg-right">
        <div className="d-flex d-lg-block justify-content-between">
          <div className="d-lg-none text-muted pr-2">
            {tLabels("billingDetail.unitPrice")}
          </div>
          <div>
            <PriceFormatter
              amount={billingDetail.unitPrice!}
              currency={billingDetail.currency!}
            />
          </div>
        </div>
      </div>
      <div className="col-lg-2 text-lg-right">
        <div className="d-flex d-lg-block justify-content-between">
          <div className="d-lg-none text-muted pr-2">
            {tLabels("billingDetail.total")}
          </div>
          <div>
            <PriceFormatter
              amount={billingDetail.amount!}
              currency={billingDetail.currency!}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BillingDetail;
